import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import "./css/BannerSlide.scss";

// Components

import Buttons from "../components/Buttons";

// Assets

import HeroImage from "../assets/images/hero-img.png";
import AppBanner from "../assets/images/app-banner.png";
import AppStore from "../assets/images/btn-app-store.png";
import PlayStore from "../assets/images/btn-google-play.png";
import ConsultADoc from "../assets/images/consult-a-doc.gif";

const Banner_1 = () => {
  return (
    <>
      <motion.div className='item-container item-1'>
        <div className='text-container'>
          <h1>
            Professional and cost-friendly healthcare management for the
            Filipino worker.
          </h1>
          <div>
            The financial devastation that often results from the sudden onset
            of a major illness or an accidental injury suffered by the ordinary
            employee is a commonly shared concern by both the latter’s family
            and his employer. The realities of the times, however, often make
            the setting aside of the financial resources needed to protect the
            average daily wage earner from this danger take the budgetary
            backseat.
          </div>
          <Buttons text={"Read More"} color={"primary"} link='about' />
        </div>
        <div className='image-container'>
          <img src={HeroImage} alt='hero-image'></img>
        </div>
      </motion.div>
    </>
  );
};

const Banner_2 = () => {
  return (
    <>
      <motion.div className='item-container item-2'>
        <div className='text-container'>
          <h1>
            Giving you full access of your benefit coverage and our wide variety
            of services.
          </h1>
          <div>
            Tenetur eligendi omnis minima voluptatum sed aliquid quisquam
            aspernatur. Maiores qui fugiat inventore distinctio sint. Molestiae
            occaecati voluptate expedita qui reiciendis. Sunt debitis excepturi
            cumque libero porro. Excepturi eaque iusto necessitatibus quis quis.
            Odio possimus accusamus recusandae aperiam dolor aut alias. Deserunt
            voluptates iure quisquam ut nisi. Sunt repellat maiores temporibus.
            Ab reiciendis laudantium repellat est quia molestiae quo pariatur.
            Ullam eveniet dignissimos et non doloremque.
          </div>
          <div className='dl-app'>
            <img src={AppStore} className='button-app' alt='app-store-button' />
            <img
              src={PlayStore}
              className='button-app'
              alt='play-store-button'
            />
          </div>
        </div>
        <div className='image-container'>
          <img src={AppBanner} alt='hero-image'></img>
        </div>
      </motion.div>
    </>
  );
};

const Banner_3 = () => {
  return (
    <>
      <motion.div className='item-container item-3'>
        <div className='text-container'>
          <h1>
            Partnership with Consult a Doc for our Telemedicine Consultation
            Service.
          </h1>
          <div>
            Hic dolorum ipsa atque eius ea. Rerum facilis eum omnis eius non
            cupiditate odit error. Omnis enim eveniet atque ea asperiores
            blanditiis non adipisci. Quia doloribus modi aliquam et et fugiat
            qui quo. Facilis sed dolor sint. Ea dolore non autem. Voluptatem
            cumque quasi cupiditate laboriosam sit temporibus. Eveniet
            dignissimos odit minima molestias voluptatibus dolor cupiditate.
            Voluptas et ipsum corrupti accusamus impedit ut porro occaecati.
            Alias accusamus praesentium qui. Soluta exercitationem et
            consequatur vitae. Atque fugiat nam harum praesentium accusamus
            exercitationem ipsa. Et accusantium autem et sed iure maiores
            numquam. Possimus blanditiis qui sit quo cupiditate. Cumque
            blanditiis dolorem eaque.
          </div>
        </div>
        <div className='image-container'>
          <img src={ConsultADoc} alt='consult-a-doc'></img>
        </div>
      </motion.div>
    </>
  );
};

const ActiveSlide = ({ index }) => {
  if (index === 0) {
    return <Banner_1 />;
  } else if (index === 1) {
    return <Banner_2 />;
  } else {
    return <Banner_3 />;
  }
};

const BannerSlide = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  const slideItemVariants = {
    initial: {
      opacity: 0,
      y: -100,
      transition: {
        ease: [0.6, 0.01, -0.05, 0.95],
        duration: 0.6,
      },
    },
    animate: {
      opacity: 1,
      y: 0,
      transition: {
        ease: [0.6, 0.01, -0.05, 0.95],
        duration: 1,
      },
    },
    exit: {
      opacity: 0,
      y: 100,
      transition: {
        ease: [0.6, 0.01, -0.05, 0.95],
        duration: 0.3,
      },
    },
  };

  const buttonVariants = {
    initial: {
      color: "var(--secondary)",
      // cursor: "pointer",
    },
    animate: {
      color: "var(--primary)",
      // cursor: "pointer",
    },
  };

  const handleNextClick = (e) => {
    if (activeSlide === 2) {
      setActiveSlide(0);
    } else {
      setActiveSlide(activeSlide + 1);
    }
  };

  const handlePrevClick = (e) => {
    if (activeSlide === 0) {
      setActiveSlide(2);
    } else {
      setActiveSlide(activeSlide - 1);
    }
  };

  return (
    <motion.div className='banner-slide-main'>
      <motion.div className='slide-inner'>
        <AnimatePresence>
          <motion.div
            className='slide-item'
            variants={slideItemVariants}
            initial='exit'
            animate='animate'
            exit='exit'
            key={activeSlide}
          >
            <ActiveSlide index={activeSlide} />
          </motion.div>
        </AnimatePresence>
        {/* <motion.div className='slide-item item-2'></motion.div>
        <motion.div className='slide-item item-3'></motion.div>
        <motion.div className='slide-item item-4'></motion.div> */}
      </motion.div>
      <motion.div className='slide-nav'>
        <motion.div
          className='btn-left'
          variants={buttonVariants}
          initial='initial'
          whileHover='animate'
          // onClick={() => {
          //   handlePrevClick();
          // }}
        >
          {/* <ArrowLeftCircle /> */}
        </motion.div>
        <motion.div
          className='btn-right'
          variants={buttonVariants}
          initial='initial'
          whileHover='animate'
          // onClick={() => {
          //   handleNextClick();
          // }}
        >
          {/* <ArrowRightCircle /> */}
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default BannerSlide;
